import React from 'react';
import { featuredTitles } from '../../data/blackout';
export function FeaturedInSection() {
  return <section id="featured" className="border-t border-gunmetal/60 bg-carbon py-20 md:py-28" data-id="element-151" data-mp="39bvf7p8yqaby">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-152" data-mp="3nbczbrbbczez">
        <div className="mb-10 grid gap-5 md:mb-14 md:grid-cols-12 md:items-end" data-id="element-153" data-mp="3n8qqlocosdv6">
          <h2 className="font-display text-5xl uppercase leading-[0.95] text-bone md:col-span-7 md:text-7xl" data-id="element-154" data-mp="3j7oqz6euxzso">
            Seen on screen.
            <span className="block text-steel" data-id="element-155" data-mp="3s9y0pu2axp50">Built for the real world.</span>
          </h2>
          <p className="max-w-md text-base leading-relaxed text-steel md:col-span-5 md:justify-self-end md:text-lg" data-id="element-156" data-mp="atgdl5kwpfl3">
            The same skull-face silhouette featured in major motion pictures,
            AAA video games, and tactical loadouts worldwide.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-4 lg:grid-cols-4" data-id="element-157" data-mp="js1pwizsbydf">
          {featuredTitles.map(item => <article key={item.title} className="flex flex-col border border-gunmetal/70 bg-obsidian" data-id="element-158" data-mp="u4sicry30kxh">
              <div className="relative aspect-[3/4] overflow-hidden bg-obsidian" data-id="element-159" data-mp="z4n64mmk8ueb">
                <img src={item.image} alt={item.title} loading="lazy" className="absolute inset-0 h-full w-full object-cover" data-id="element-160" data-mp="142oyjy5vm62g" />
                <span className="absolute right-2 top-2 bg-obsidian/85 px-2 py-1 text-[10px] font-medium uppercase tracking-[0.14em] text-bone backdrop-blur-sm md:right-3 md:top-3" data-id="element-161" data-mp="1d2vcfl5hl825">
                  {item.platform}
                </span>
              </div>
              <div className="border-t border-gunmetal/70 p-4" data-id="element-162" data-mp="1rs9mkvgvztil">
                <p className="truncate text-[11px] font-medium uppercase tracking-[0.14em] text-steel" data-id="element-163" data-mp="1rrrjpfzpyh1p">
                  {item.type}
                </p>
                <h3 className="mt-2 font-display text-xl uppercase leading-none text-bone md:text-2xl" data-id="element-164" data-mp="20sfwk7ddmbd0">
                  {item.title}
                </h3>
                <p className="mt-1.5 truncate text-xs text-steel" data-id="element-165" data-mp="1m3bm4tib9id">
                  {item.subtitle}
                </p>
              </div>
            </article>)}
        </div>

        <p className="mx-auto mt-12 max-w-3xl border-l-2 border-signal pl-5 text-[15px] leading-relaxed text-steel" data-id="element-166" data-mp="ai2mm0c3890x">
          The iconic skull-face mask design has become a cultural symbol — from
          Simon “Ghost” Riley in <span className="text-bone" data-id="element-167" data-mp="ffumphmvz1g7">Call of Duty</span>
          , to the heist crews of <span className="text-bone" data-id="element-168" data-mp="fhyp1v54zsed">The Town</span>{' '}
          and <span className="text-bone" data-id="element-169" data-mp="tely2wad690n">Marauders</span>, to tactical
          enthusiasts everywhere. Now, you own the version actually built to
          perform.
        </p>
      </div>
    </section>;
}